<template>
  <Card>
    <h1 slot="Title">General Ledger Account Categories</h1>
    <div slot="MainContent">
      <p>
        General accounts are broken into seven categories: assets, liabilities, net position, revenue, expense, gains and losses: 
      </p>
      <ul>
        <li>
          Assets are basically all things owned by the company that are of any value. 
        </li>
        <li>
          Liabilities are anything owed by the company. 
        </li>
        <li>
          Net position is the result of the value of the assets minus the liabilities. 
        </li>
        <li>
          Revenue is the income brought in by the operating of the business. 
        </li>
        <li>
          Expense is the spending of money by the company to operate the business. 
        </li>
        <li>
          Gains and losses are the incoming and outgoing of funds that do not have to do with the normal revenue and expense. 
        </li>
      </ul>
    </div>
    <p><strong>General Ledger Accounts Categories</strong></p>
    <p><strong>Asset:&nbsp;&nbsp; </strong>automobile, computer, home</p>
    <p><strong>Liabilities</strong>:&nbsp; credit card debt, loan,</p>
    <p><strong>Net Position : </strong>Foreign exchange currency, commodities. It can also be the amount or total assets held by an organization as well as the ownership status of a institution&rsquo;s investments.&nbsp;</p>
    <p><strong>Net Position : </strong>example could be if you owned rental property the funds received from the rent is the revenue.&nbsp; The sale of automobiles at a car lot would be a revenue. (income that a company receives from its normal business)&nbsp;&nbsp;</p>
    <p><strong>Expense:&nbsp; </strong>Utilities (electric, water, gas) cable bill, cell phone bill, travel, office supplies</p>
    <p><strong>Gains or losses:&nbsp;&nbsp;&nbsp; </strong>Gains or losses result from the sale, exchange, trade or disposition of government assets.&nbsp; Gains or Losses. When a transaction occurs with the public or another government entity for a price which is unusual or nonrecurring, a gain or loss must be recognized rather than revenue or expense so as to differentiate such transactions. Gains or losses result from the sale, exchange, trade or disposition of government assets (with the exception of inventory held for sale)6. As a general rule, any difference between the sales proceeds at more or less than the book value of an asset is recognized as a gain or loss when the asset is sold.</p>
    <p>EXAMPLE:&nbsp; The reclassification of excess, obsolete, or unserviceable inventory will generally result in a loss when revalued because the value is now less than the acquisition or moving average cost of the item. The amount of revaluation is recognized as a loss or gain in determining the net cost of operations.&nbsp; Example: initial issue of equipment, when it is turned in the value has depreciated because of normal wear and tear.&nbsp; It is not the same value when it was received.&nbsp;</p>
  </Card>
</template>
<style scoped>
  ul > li {
    margin-bottom: 0;
  }
</style>
<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'General Ledger Account Categories',
  
  data() {
    return {
    }
  }
  
}
</script>